import toast from "react-hot-toast";

const VoiceCloneVoiceCard = ({recording, isPlaying, onPlay, removeAudioRecordingHandler}) => {
    if (!recording?.blob || !(recording.blob instanceof Blob)) {
        toast.error("No valid recording found. Please record again.");
        return null;
    }

    return (
        <div key={recording?.id} className="bg-[#c8ceda4d] rounded-xl transition duration-200 ease-in-out py-2 px-3 flex justify-between items-center">
            <div className="flex flex-row gap-2 items-center">
                <div
                    onClick={onPlay}
                    className="cursor-pointer bg-slate-700 hover:bg-slate-800 rounded-full flex justify-center items-center w-[35px] h-[35px]">
                    {isPlaying ? ( <i className="fa-solid text-white fa-pause"></i> ) : ( <i className="fa-solid ml-[3px] text-white fa-play"></i>) }
                </div>
                <div className="flex flex-col justify-between text-[12px]">
                    <p className="text-slate-700">{recording?.name} - {recording?.size} MB</p>
                    <p className="text-slate-600">{Number(recording?.time).toFixed(2)}s</p>
                </div>
            </div>
            <div onClick={()=>{removeAudioRecordingHandler(recording)}} className="cursor-pointer bg-red-600 hover:bg-red-700 transition duration-200 ease-in-out rounded-full flex justify-center items-center w-[15px] h-[15px]">
                <i className="fa-solid text-[10px] text-white fa-xmark"></i>
            </div>
        </div>
    )

}

export default VoiceCloneVoiceCard